<template>
  <div></div>
</template>
<script>
export default {
  props: {
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  watch: {
    payLoad(newVal) {
      if (newVal) {
        this.doRedirect(newVal)
      }
    }
  },
  methods: {
    async doRedirect(props) {
      const platform = await this.getEnv()
      if (platform === 1 && props.mpLink && this.tjChannelId === 'tujia') {
        // eslint-disable-next-line
        wx.miniProgram&&wx.miniProgram.navigateTo({url: props.mpLink})
      } else if (platform === 2 && props.appLink) {
        window.location.href = props.appLink
      } else if (props.activeLink) {
        window.location.href = props.activeLink
      }
    }
  }
}
</script>
